import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import CtaBasic from "../components/CTAbasic";

const BoreHoleETR = props => {
  const post = props.data.markdownRemark;

  return (
    <>
      <SEO
        title={post.frontmatter.title}
        image={post.frontmatter.image}
        description={post.frontmatter.description}
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{ backgroundImage: `url(${post.frontmatter.image})` }}
      >
        <div className="bg-overlay" />
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="BoreHoleETRs-heading title-heading">
                <h2 className="text-white title-dark">
                  {" "}
                  {post.frontmatter.title}{" "}
                </h2>
                <p className="text-white-50 para-desc mb-0 mx-auto">
                  {post.frontmatter.description
                    ? post.frontmatter.description
                    : null}
                </p>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}
        </div>{" "}
        {/*end container*/}
      </section>
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      <section class="section">
        <div class="container">

  <div class="row">
  <p>Sintilasyon radyometresi SRP-20</p>
<p>Ana &ouml;zellikleri:</p>
<p>⦁ &nbsp; &nbsp;Kaya&ccedil;ların doğal radyoaktivitesinin hızlı değerlendirilmesi</p>
<p>⦁ &nbsp; &nbsp;Y&uuml;ksek &ouml;l&ccedil;&uuml;m hassasiyeti</p>
<p>⦁ &nbsp; &nbsp;Taşınabilir ve kullanımı kolay</p>
<p>⦁ &nbsp; &nbsp;Ayarlanabilir ortalama alma penceresi</p>
<p>⦁ &nbsp; &nbsp;Kontrol kaynağı ile birlikte verilir (Co-60)</p>
<p>Sondaj deliği sintilasyon radyometresi SRP-20 - iyi bilinen tomruk radyometreleri SRP-97K ve SRP-68-02/03&apos;&uuml;n en gelişmiş versiyonu ve işlevsellik ve uygulama a&ccedil;ısından analogları. Cihaz, 300 m derinliğe kadar kuyularda ve sondajlarda gama ışını kaydı yapmak i&ccedil;in tasarlanmıştır. Sondaj deliği ve el tipi (SRP-68-01, SRP-88 ve SRP-97&apos;nin analogu) versiyonları seri &uuml;retimdedir.</p>
<p>Gama ışını kaydı yapılırken, gama radyasyonunun yoğunluğunu &mu;R/saat cinsinden g&ouml;steren s&uuml;rekli bir eğri veya grafik kaydedilir. Ana kaya tarafından doğal absorpsiyon nedeniyle, parıldama detekt&ouml;r&uuml;nden 30 cm&apos;ye kadar bir yarı&ccedil;ap i&ccedil;indeki kayalardan ve nesnelerden iyonlaştırıcı radyasyon kaydedilir.</p>
<p>Neden SRP-20?</p>
<p>⦁ &nbsp; &nbsp;Sondaj deliği radyometresi SRP-20, hem prob hem de kontrol &uuml;nitesi i&ccedil;erir, b&ouml;ylece gama ışını kaydı i&ccedil;in yeterli sistem haline gelir</p>
<p>⦁ &nbsp; &nbsp;Sondaj deliği versiyonunun su ge&ccedil;irmez algılama &uuml;nitesi, hem kuru / sıvı sondaj delikleriyle dolu hem de her t&uuml;rl&uuml; muhafaza ile (veya onsuz) kullanılabilir</p>
<p>⦁ &nbsp; &nbsp;Su ge&ccedil;irmez kontrol &uuml;nitesi</p>
<p>⦁ &nbsp; &nbsp;Kullanıcı dostu aray&uuml;z ve basit kullanım</p>
<p>⦁ &nbsp; &nbsp;Dahili Bluetooth ve USB, bir PC veya akıllı telefonda (tablet) ger&ccedil;ek zamanlı veri g&ouml;rselleştirme sağlar</p>
<p>⦁ &nbsp; &nbsp;Cihaz, probu yatay, eğimli ve y&uuml;kselen kuyularda ve sondajlarda kullanmak i&ccedil;in bir kuyu kayıt &ccedil;ubuğu besleme sistemi ve bir dizi &ccedil;ubuk ile tedarik edilebilir</p>
<p>⦁ &nbsp; &nbsp;Zaman ortalaması penceresinin ayarlanması, d&uuml;ş&uuml;k seviyeli anormalliklerde kararlı verilerin kaydedilmesini sağlar ve hızlı tarama sırasında anında yanıt verir</p>
<p>⦁ &nbsp; &nbsp;İsteğe bağlı olarak, algılama &uuml;nitesi 300 m&apos;den daha derin sondaj deliklerine yerleştirilmek &uuml;zere &uuml;retilebilir</p>
<p>⦁ &nbsp; &nbsp;Step motorla donatılmış, kullanımı kolay işaret&ccedil;i g&ouml;stergesi, &ouml;l&ccedil;&uuml;m konsolu hareketinden kaynaklanan salınımları ortadan kaldırır</p>
<p>⦁ &nbsp; &nbsp;G&ouml;sterge arka ışığı, her koşulda konfor &ouml;l&ccedil;&uuml;mleri sağlar</p>
<p>⦁ &nbsp; &nbsp;Sağlam taşıma &ccedil;antası, Co-60 kontrol kaynağı ve y&uuml;ksek kaliteli a&ccedil;ık tip kulaklıklar</p>
<p>SRP-20 uygulama alanları:</p>
<p>⦁ &nbsp; &nbsp;Radyoaktif / radyoaktif olmayan cevher arama</p>
<p>⦁ &nbsp; &nbsp;Sondaj kuyularında litoloji &ccedil;alışmaları</p>
<p>⦁ &nbsp; &nbsp;Rezervuar aralıklarının tanımlanması ve iyileştirilmesi (petrol ve gaza doymuş oluşumlar)</p>
<p>⦁ &nbsp; &nbsp;Delme işlemleri sırasında derinliğe bağlama</p>
<p>⦁ &nbsp; &nbsp;Kil i&ccedil;eriğinin belirlenmesi ve kayaların kırılması</p>
<p>Paket i&ccedil;eriği:</p>
<p>⦁ &nbsp; &nbsp;G&uuml;nl&uuml;ğe kaydetme araştırması</p>
<p>⦁ &nbsp; &nbsp;Dahili pilli &ouml;l&ccedil;&uuml;m konsolu</p>
<p>⦁ &nbsp; &nbsp;Şarj cihazı</p>
<p>⦁ &nbsp; &nbsp;Kulaklık</p>
<p>⦁ &nbsp; &nbsp;Bir kaptaki kontrol kaynağı (Co-60)</p>
<p>⦁ &nbsp; &nbsp;Sağlam Kılıf</p>
<p>⦁ &nbsp; &nbsp;Kayma halkalı makara</p>
<p>⦁ &nbsp; &nbsp;&Ccedil;ubuklu kuyu tomruk &ccedil;ubuğu besleme sistemi (isteğe bağlı olarak)</p>
<p>Gama radyasyonunun maruz kalma doz oranının &ouml;l&ccedil;&uuml;m aralığı &nbsp; &nbsp;0 &divide; 3 000 mcR/saat</p>
<p>226Ra radyon&uuml;klidin gama radyasyonunun maruziyet doz hızının &ouml;l&ccedil;&uuml;m&uuml;nde temel hata &nbsp; &nbsp;en fazla %&plusmn;15 (30 mcR/h &ouml;l&ccedil;&uuml;m alt aralığında standartlaştırılmamıştır)</p>
<p>Kaydedilen gama ortalama sayım hızının &ouml;l&ccedil;&uuml;m aralığı &nbsp; &nbsp;0 &divide; 10 000 s-1</p>
<p>Kaydedilen gama ortalama sayım hızının &ouml;l&ccedil;&uuml;m&uuml;nde temel hata &nbsp; &nbsp;%&plusmn;10&apos;dan fazla değil</p>
<p>Gama tespitinin enerji aralığı &nbsp; &nbsp;35 &divide; 3 000 keV</p>
<p>Ortalama alma penceresinin varyasyon sınırı &nbsp; &nbsp;1 &divide; 20 sn</p>
<p>&Ccedil;alışma modunun ayarlanma s&uuml;resi &nbsp; &nbsp;en fazla 1 dakika</p>
<p>G&uuml;&ccedil; kaynağı voltajı &nbsp; &nbsp;12,5 &plusmn; 2 V</p>
<p>Ortalama g&uuml;&ccedil; &nbsp; &nbsp;0,9 W</p>
<p>G&uuml;&ccedil; kaynağının &ouml;mr&uuml; &nbsp; &nbsp;en az 25 saat</p>
<p>&Ccedil;alışma sıcaklığı aralığı &nbsp; &nbsp;-40 &divide; +50 ˚С</p>
<p>Boyutlar</p>
<p>- Algılama &uuml;nitesi &nbsp; &nbsp;36 &times; 1010 mm</p>
<p>- G&uuml;&ccedil; beslemeli &ouml;l&ccedil;&uuml;m konsolu &nbsp; &nbsp;200 &times; 90 &times; 145 mm</p>
<p>Arabirim &nbsp; &nbsp;USB, Bluetooth</p>
<p>Ağırlık</p>
<p>- Algılama &uuml;nitesi &nbsp; &nbsp;2,5 kg</p>
<p>- G&uuml;&ccedil; beslemeli &ouml;l&ccedil;&uuml;m konsolu &nbsp; &nbsp;2,6 kg</p>
</div>
</div>

      </section>
      {post.frontmatter.cta ? <CtaBasic /> : null}
    </>
  );
};

export const query = graphql`
  query BoreHoleETR($locale: String!, $title: String!) {
    markdownRemark(
      frontmatter: { title: { eq: $title } }
      fields: { locale: { eq: $locale } }
    ) {
      frontmatter {
        title
        description
        image
        cta
      }
      html
    }
  }
`;

export default BoreHoleETR;